<div id="auditQuantityDialog" class="modal modal-med modal-dialog fade in" role="dialog" style="display: none;position:absolute !important" 
    appDraggable dragTarget="#auditQuantityDialog" dragHandle="#auditQuantityDialogHeader" data-backdrop="static" data-keyboard="false">
  <div class="modal-content">

    <!-- Header -->
    <div class="modal-header" id="auditQuantityDialogHeader">
      <button type="button" class="close" (click)="hide()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
      <h4 class="modal-title">Override Audit Quantity</h4>
    </div>

    <!-- Body -->
    <div class="modal-body">

      <div class="row">
        <div class="form-group">
          <div class="col-sm-4">
            <label class="labelRequired">Audit Quantity: </label>
          </div>
          <div class="col-sm-6">
            <input class="form-control" type="number" [(ngModel)]="auditQuantity" />
          </div>
        </div>
      </div>

      <ng-container *ngFor="let rc of reasonCodesAndComments; index as i">
        <div class="row">
          <div class="form-group">
            <div class="col-sm-4">
              <label class="labelRequired">Reason Code: </label>
            </div>
            <div class="col-sm-6">
              <select class="form-control" [(ngModel)]="rc.reasonCode" (ngModelChange)="onReasonCodeChanged()">
                  <option [ngValue]="undefined"> -- Choose Reason Code -- </option>
                  <option *ngFor="let reasonCode of getAvailableReasonCodesForIndex(i)" [ngValue]="reasonCode">{{ reasonCode.reason_code }} - {{ reasonCode.description }}</option>
              </select>
            </div>
            <div class="col-sm-1">
              <ng-container *ngIf="i == 0">
                <button class="btn btn-ef" (click)="onAddReasonCodeClicked()")>
                  <i class="fa fa-plus"></i>
                </button>
              </ng-container>
              <ng-container *ngIf="i > 0">
                <button class="btn btn-default" (click)="onRemoveReasonCodeClicked(i)">
                  <i class="fa fa-minus"></i>
                </button>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="rc.reasonCode?.allows_comments">
          <div class="form-group">
            <div class="col-sm-4">
              <label class="labelNormal">Comment</label>
            </div>
            <div class="col-sm-6">
              <textarea rows="4" cols="40" class="form-control" [(ngModel)]="rc.comment"></textarea>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" (click)="onCancelClicked()" class="btn btn-default">
        <i class="fa fa-ban" aria-hidden="true"></i> CANCEL
      </button>
      <button type="button" (click)="onSetClicked()" class="btn btn-primary">
        <i class="fa fa-refresh" aria-hidden="true"></i> SET
      </button>
    </div>
  </div>
</div>